import React, { Component, Fragment } from 'react';
import Layers from './Layers';
import Filters from './Filters';
import Map from './Map';
import TableView from './TableView';
import SnapshotLeftTable from './SnapshotLeftTable';
import SnapshotContainer from 'bundles/Dashboard/containers/SnapshotContainer';
import UploadComponent from './UploadComponent';
import Modal from 'shared/components/Modal';
import Sidebar from 'shared/components/Sidebar';
import FunctionArea from './FunctionArea';
import { isAfter, isBefore } from "date-fns";
import { objIsEqual, handleFiltering, handleFilteringPipeline, getFiltersForTxt,
    transformDataForTable, dataURItoBlob, getKeyByValue } from 'shared/helpers';
import html2canvas from 'html2canvas';
import ObjectsToCsv from 'objects-to-csv'
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { getDate, getMonth, getHours, getMinutes, getSeconds } from "date-fns";
import * as turf from '@turf/turf';
import * as d3 from "d3";
// import { fil } from 'date-fns/locale';

class DashboardComponent extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedMenuItem: undefined,
            mapOrTable: 0,
            filteredData: props.housingData,
            filteredPipelineData: props.pipelineData,
            displayGeography: '',
            formattedFilters: undefined,
            formattedFiltersPipeline:undefined,
            filterInputs: {
                risk: '',
                minSubUnits: '',
                maxSubUnits: '',
                minPerUnitSub: '',
                maxPerUnitSub: '',
                ami: '',
                funding: '',
                population: '',
                housing: '',
                subStartDateBegin: null,
                subStartDateEnd: null,
                subEndDateBegin: null,
                subEndDateEnd: null,
                stewarding: '',

                
                
            },
            switchesInFilter:{
                tenure: '',
                affordabilityThreshold: '',
                afforabilityTerm: '',
                construction: false,
                permanentSupportativeHousing: false,
                communityLandTrust: false,
                greenCertified: false,
                innovation: false,
                nonprofit: false,
                bIPOC: false,
                families: false,
                seniors: false,
                formerlyHomeless: false,
            },
            switches: {
                // earlyEducation: false,
                foodDeserts: false,
                transportation: false,
                transit: false,
                // lowIncomeTenants: false,
                affordableUnits: false,
                risingRents: false,
                // gentrification: false,
                race: false,
                income: false,
            },
            showNoResultsModal: false,
            rawResultsCount: props.housingData ? props.housingData.features.length : 0,
            filterResultsCount: props.housingData ? props.housingData.features.length : 0,
            totalSubUnits: props.housingData ? this.getTotalSubsidizedUnits(props.housingData.features) : 0,
            totalRiskUnits: props.housingData ? this.getRiskUnits(props.housingData.features) : 0,
            rawResultsCountPipeline: props.pipelineData ? props.pipelineData.features.length : 0,
            filterResultsCountPipeline: props.pipelineData ? props.pipelineData.features.length : 0,
            //todo
            totalSubUnitsPipeline: props.pipelineData ? this.getTotalSubsidizedUnitsPipeline(props.pipelineData.features) : 0,
            // totalRiskUnitsPipeline: props.pipelineData ? this.getRiskUnits(props.pipelineData.features) : 0,
            requestedRef: null,
            foodDesertData:null,
            transportationData:null,
            transitData:null,
            lossAffordableHousingData:null,
            risingRentData:null,
            raceData:null,
            foodDesertDataFilter:null,
            transportationDataFilter:null,
            transitDataFilter:null,
            lossAffordableHousingDataFilter:null,
            risingRentDataFilter:null,
            raceDataFilter:null,
            incomeDataFilter:null,
            filteredCurrentLayerData:null,
            housingDataAfterAttributeFiltering:props.housingData,
            pipelineDataAfterAttributeFiltering:props.pipelineData,
            transportationDataFilterRange:[0,0],
            foodDesertDataFilterRange:[0,0],
            lossAffordableHousingDataFilterRange:[0,0],
            risingRentDataFilterRange:[0,0],
            raceDataFilterRange:[0,0],
            incomeDataFilterRange:[0,0],
            //0 means uncovered, 1 means covered and 2 means all 
            transitDataFilterChoice:2,
            filteredHousingDataByTransitLayerFilter:null,
            columnsPipeline:[]
        }



        
    }

    componentWillMount() {
     
        this.setState({ foodDesertData: require('assets/data/layers/food_deserts.json') })
        this.setState({ transportationData: require('assets/data/layers/CommuteTime_Under25min_Tracts.json') })
        // this.setState({ transitData: require('assets/data/layers/RailBusBuffer.json') })
        this.setState({ transitData: require('assets/data/layers/serviceAreaTransit84.json') })
        this.setState({ lossAffordableHousingData: require('assets/data/layers/Loss_AfordableHousing.json') })
        this.setState({ risingRentData: require('assets/data/layers/zillow_zip_rent_increase.json') })
        this.setState({ raceData: require('assets/data/layers/ATL_Race.json') })

        this.setState({ foodDesertDataFilter: require('assets/data/layers/food_deserts.json') })
        this.setState({ transportationDataFilter: require('assets/data/layers/CommuteTime_Under25min_Tracts.json') })
        // this.setState({ transitDataFilter: require('assets/data/layers/RailBusBuffer.json') })
        this.setState({ transitDataFilter: require('assets/data/layers/serviceAreaTransit84.json') })
        this.setState({ lossAffordableHousingDataFilter: require('assets/data/layers/Loss_AfordableHousing.json') })
        this.setState({ risingRentDataFilter: require('assets/data/layers/zillow_zip_rent_increase.json') })
        this.setState({ raceDataFilter: require('assets/data/layers/ATL_Race.json') })
        this.setState({ incomeDataFilter: require('assets/data/layers/ATL_Race.json') })


        d3.csv(require('assets/data/csvs/TableManifest.csv')).then(function(csvFile) {

            const newCsvFile = csvFile.map(function(num){
                var newdict = {}
                // replace dot to underscore for all fieldnames
                for (var [key, value] of Object.entries(num)) {
                    newdict[key] = value
                    
                }
                return newdict
            })
        
            this.setState({columnsPipeline:newCsvFile})
    
            }.bind(this))

    }



    componentDidUpdate(prevProps, prevState) {
        const { formattedFilters,formattedFiltersPipeline,filteredCurrentLayerData,housingDataAfterAttributeFiltering,transitDataFilterChoice } = this.state;
        const { housingData, pipelineData, housingNPUData, fetchHousingNPUData} = this.props;


        if (!housingNPUData && housingData) {
            //console.log(housingData);
            fetchHousingNPUData(housingData);
        }


        if (!objIsEqual(prevState.formattedFilters, formattedFilters)) {
            const updated = handleFiltering(housingData.features, formattedFilters)

            this.setState({
                housingDataAfterAttributeFiltering:{features: updated, type: 'FeatureCollection',},
                filteredData: { features: updated, type: 'FeatureCollection', },
                filterResultsCount: updated.length,
                totalSubUnits: this.getTotalSubsidizedUnits(updated, formattedFilters),
                totalRiskUnits: this.getRiskUnits(updated),
            })

            // console.log("update geography based on filtered data")
            fetchHousingNPUData({ features: updated, type: 'FeatureCollection', });

            if (updated.length === 0) {
                this.setState({ showNoResultsModal: true })
            }
        }

        if (!objIsEqual(prevState.formattedFiltersPipeline, formattedFiltersPipeline)) {
            const updated = handleFilteringPipeline(pipelineData.features, formattedFiltersPipeline)

            this.setState({
                pipelineDataAfterAttributeFiltering:{features: updated, type: 'FeatureCollection',},
                filteredPipelineData: { features: updated, type: 'FeatureCollection', },
                filterResultsCountPipeline: updated.length,
                totalSubUnitsPipeline: this.getTotalSubsidizedUnitsPipeline(updated),
                // totalRiskUnits: this.getRiskUnits(updated),
            })

            // console.log("update geography based on filtered data")
            //todo:
            // fetchHousingNPUData({ features: updated, type: 'FeatureCollection', });

            if (updated.length === 0) {
                this.setState({ showNoResultsModal: true })
            }
        }

        if (!objIsEqual(prevState.filteredCurrentLayerData, filteredCurrentLayerData)) {
            
             // find those points within polygons
            const filteredHousingDataByLayerFilter = housingDataAfterAttributeFiltering.features.filter(function(item){ 
                for(var poly of filteredCurrentLayerData.features) {
                    var isIn = turf.inside(item, poly);
                    if(isIn){
                        return true
                    }
                }
                return false
            })

            const { formattedFilters , formattedFiltersPipeline, switches} = this.state;
            const { housingData,pipelineData} = this.props;

            //console.log(filteredHousingDataByLayerFilter);
            const whichLayer = getKeyByValue(switches, true);
            //console.log(whichLayer)
            if(whichLayer){
                this.applyLayerFilterTohouseData(filteredHousingDataByLayerFilter)
            }else{                
                this.resetFilteredData(formattedFilters,housingData)
                this.resetFilteredDataPipeline(formattedFiltersPipeline,pipelineData)
            }
        }

        if (!objIsEqual(prevState.transitDataFilterChoice, transitDataFilterChoice)) {
            const { transitData} = this.state;

            var filteredHousingDataByLayerFilter;
            // find those points within polygons
            if (transitDataFilterChoice === 1 ){
                filteredHousingDataByLayerFilter = housingDataAfterAttributeFiltering.features.filter(function(item){ 
                    for(var poly of transitData.features) {
                        var isIn = turf.inside(item, poly);
                        if(isIn){
                            return true
                        }
                    }
                    return false
                })
            }else if (transitDataFilterChoice === 0){
                filteredHousingDataByLayerFilter = housingDataAfterAttributeFiltering.features.filter(function(item){ 
                    for(var poly of transitData.features) {
                        var isIn = turf.inside(item, poly);
                        if(isIn){
                            return false
                        }
                    }
                    return true
                })
              
            }else{
            
                filteredHousingDataByLayerFilter = housingDataAfterAttributeFiltering.features
            }

            this.setState({filteredHousingDataByTransitLayerFilter:filteredHousingDataByLayerFilter})

            this.applyLayerFilterTohouseData(filteredHousingDataByLayerFilter)
            
       }
    }

    resetFilteredData =(formattedFilters,housingData)=>{
        if(formattedFilters){
            const updated = handleFiltering(housingData.features, formattedFilters)
            this.setState({
                filteredData: { features: updated, type: 'FeatureCollection', },
                filterResultsCount: updated.length,
                totalSubUnits: this.getTotalSubsidizedUnits(updated),
                totalRiskUnits: this.getRiskUnits(updated),
            });
        }else{

            this.setState({
                filteredData: { features: housingData.features, type: 'FeatureCollection', },
                filterResultsCount: housingData.features.length,
                totalSubUnits: this.getTotalSubsidizedUnits(housingData.features),
                totalRiskUnits: this.getRiskUnits(housingData.features),
            });
        }
    }

    resetFilteredDataPipeline =(formattedFiltersPipeline,pipelineData)=>{
        if(formattedFiltersPipeline){
            const updated = handleFilteringPipeline(pipelineData.features, formattedFiltersPipeline)
            this.setState({
                filteredPipelineData: { features: updated, type: 'FeatureCollection', },
                filterResultsCountPipeline: updated.length,
                totalSubUnitsPipeline: this.getTotalSubsidizedUnitsPipeline(updated),
                // totalRiskUnits: this.getRiskUnits(updated),
            });
        }else{

            this.setState({
                filteredPipelineData: { features: pipelineData.features, type: 'FeatureCollection', },
                filterResultsCountPipeline: pipelineData.features.length,
                totalSubUnitsPipeline: this.getTotalSubsidizedUnitsPipeline(pipelineData.features),
                // totalRiskUnits: this.getRiskUnits(pipelineData.features),
            });
        }
    }

    applyLayerFilterTohouseData =(filteredHousingDataByLayerFilter) =>{
        this.setState({
            filteredData: { features: filteredHousingDataByLayerFilter, type: 'FeatureCollection', },
            filterResultsCount: filteredHousingDataByLayerFilter.length,
            totalSubUnits: this.getTotalSubsidizedUnits(filteredHousingDataByLayerFilter),
            totalRiskUnits: this.getRiskUnits(filteredHousingDataByLayerFilter),
        });
    }

    getTotalSubsidizedUnits = (data, filterObj) => {
        // console.log(data, filters);
        const filters = filterObj ? filterObj['Subsidy'] : null;

        const filterByDate = (value, begin, end) => {
          if (begin && end) {
              // both have a value
              return isAfter(value, begin) && isBefore(value, end);
          } else if (begin) {
            // console.log(value, begin);
              // there is a value for begin
              return isAfter(value, begin);
          } else if (end) {
              // there is a value for end
              return isBefore(value, end);
          }
          return true;
        };
        
        const filterByAmi = (obj, filters, filterKey) => {
          const itemKeys = Object.keys(obj)
          // eslint-disable-next-line no-unused-vars
          for (const itemKey of itemKeys) {
              if (itemKey.startsWith('ami')) {
                  if (+(itemKey.split('_')[1]) <= filters[filterKey]) {
                      if (!!obj[itemKey]) {
                          return true;
                      }
                  }
              }
          }
          return false;
        }
        const getMaxUnitsFromProperty = subsidies => Math.max(...subsidies.filter((item, i) => 
              filters 
                ? Object.keys(filters).every(key => {
                  if (!filters[key]) return true;
                  if (key === "SubStart") {
                      return filterByDate(new Date(item[key]), filters[key][0], filters[key][1])
                  }
                  if (key === "SubEnd") {
                      return filterByDate(new Date(item[key]), filters[key][0], filters[key][1])
                  }
                  // if (key === "RiskUnits") {
                  //     return filterByRiskUnits(item, filters, key)
                  // }
                  if (key === "Funding") {
                      const filterIsArray = Array.isArray(filters[key]);
                      const fundingString = item[key].join(',');

                      if (fundingString) {
                        if (!filterIsArray) {
                          return fundingString.search(filters[key]) !== -1
                        } 
                        const booleanArray = []
                        filters[key].forEach(value => booleanArray.push( fundingString.search(value) !== -1))
                        return !filterIsArray ? false : booleanArray.includes(true);
                      }
                      return false;
                    }
                  if (key === "UnitAMI") {
                      return filterByAmi(item, filters, key)
                  }
                  if (key === "tenantType"){
                      const filterIsArray = Array.isArray(filters[key])
                      // console.log(filters[key]);
                      // console.log(item[key])
                      if (item[key]) {
                        if (!filterIsArray) {
                          return item[key].search(filters[key]) !== -1
                        }
                        const booleanArray = []
                        filters[key].forEach(value => booleanArray.push( item[key].search(value) !== -1))
                        return !filterIsArray ? false : booleanArray.includes(true);
                      }
                      return false;
                  }
                  return item[key].search(filters[key]) !== -1
                })
              : true
        ).map(subsidy => subsidy['UnitsSub']));

        return data.reduce((acc, curr) => acc + getMaxUnitsFromProperty(curr.properties.subsidies), 0)
    }

    getTotalSubsidizedUnitsPipeline = (data) => {
        return data.reduce((acc, curr) => acc + parseInt(curr.properties.NewConstructionUnits) + parseInt(curr.properties.PreservedUnits), 0)
    }

    getRiskUnits = (data) => {
        return data.reduce((acc, curr) => {
            const arr = curr.properties.subsidies.filter(obj => obj.RiskUnits === "Expiring within 6 months")
            // return acc + arr.length
            if (arr.length > 0){
               
                return acc + Math.max.apply(null, arr.map(function(item) {
                    return item.UnitsSub;
                }))
                
            }else{
                return acc
            }

        }, 0)
    }

    // For Display Geography dropdown
    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value })
    }

    // For filter dropdowns and inputs
    handleFilterChange = event => {
        event.persist()
        if (event.target.name) {
            this.setState(prevState => ({
                filterInputs: {
                    ...prevState.filterInputs,
                    [event.target.name]: event.target.value
                }
            }))
        } else {
            this.setState(prevState => ({
                filterInputs: {
                    ...prevState.filterInputs,
                    [event.target.id]: event.target.value
                }
            }))
        }
    }

    handleFilterChangePipeline = event => {
        event.persist()
        if (event.target.name) {
            this.setState(prevState => ({
                switchesInFilter: {
                    ...prevState.switchesInFilter,
                    [event.target.name]: event.target.value
                }
            }))
        } else {
            this.handleSwitchInFilter(event)
        }
    }

    // For different layer toggles
    handleSwitch = event => {
        event.persist();
        this.setState(prevState => {
            const copy = Object.assign({}, prevState.switches)
            Object.keys(copy)
                .forEach(key => {
                    if (key !== event.target.value) {
                        copy[key] = false
                    }
                })
            return {
                switches: {
                    ...copy,
                    [event.target.value]: event.target.checked
                }
            }
        })
    }

    handleSwitchInFilter = event => {
        event.persist();
        this.setState(prevState => {
            const copy = Object.assign({}, prevState.switchesInFilter)
            // Object.keys(copy)
            //     .forEach(key => {
            //         console.log(key)
            //         if (key !== event.target.value) {
            //             copy[key] = false
            //         }
            //     })
            return {
                switchesInFilter: {
                    ...copy,
                    [event.target.value]: event.target.checked
                }
            }
        })
    }

    handleLayerFilter = (layersDataID, filteredLayer,min,max,id) => {
    //    const {filteredData} = this.state;

    // console.log(filteredLayer)

        this.setState({filteredCurrentLayerData: { features: filteredLayer, type: 'FeatureCollection', } })
        

        this.setState({ [layersDataID]: { features: filteredLayer, type: 'FeatureCollection', } })

       

        if(id==='transportation'){
            this.setState({ transportationDataFilterRange: [min,max] })
        }else if (id==='foodDeserts'){
            this.setState({ foodDesertDataFilterRange: [min,max] })
        }else if (id==='affordableUnits'){
            this.setState({ lossAffordableHousingDataFilterRange: [min,max] })
        }else if (id==='risingRents'){
            this.setState({ risingRentDataFilterRange: [min,max] })
        }else if (id==='race'){
            this.setState({ raceDataFilterRange: [min,max] })
        }else if (id==='income'){
            this.setState({ incomeDataFilterRange: [min,max] })
        }
            



      //  console.log(transportationDataFilter)
    }

    resetRange(){
        this.setState({minRangeN: 0 })
        this.setState({maxRangeN: 0 })
    }


    makeDateHandler = (key) => (date) => {
        this.setState(prevState => ({
            filterInputs: {
                ...prevState.filterInputs,
                [key]: date,
            }
        }))
    }

    resetFilters = () => {
        this.setState({
            filterInputs: {
                risk: '',
                minSubUnits: '',
                maxSubUnits: '',
                minPerUnitSub: '',
                maxPerUnitSub: '',
                ami: '',
                funding: '',
                population: '',
                housing: '',
                subStartDateBegin: null,
                subStartDateEnd: null,
                subEndDateBegin: null,
                subEndDateEnd: null,
                stewarding: '',
            }
        }, () => { this.formatFilters() })
    }

    resetFiltersPipeline = () => {
        this.setState({
            switchesInFilter:{
                tenure: '',
                affordabilityThreshold: '',
                afforabilityTerm: '',
                construction: false,
                permanentSupportativeHousing: false,
                communityLandTrust: false,
                greenCertified: false,
                innovation: false,
                nonprofit: false,
                bIPOC: false,
                families: false,
                seniors: false,
                formerlyHomeless: false,
            }
        }, () => { this.formatFiltersPipeline() })
    }

    formatFilters = () => {
        const {
            filterInputs: {
                risk,
                minSubUnits,
                maxSubUnits,
                minPerUnitSub,
                maxPerUnitSub,
                ami,
                funding,
                population,
                housing,
                subStartDateBegin,
                subStartDateEnd,
                subEndDateBegin,
                subEndDateEnd,
                stewarding,

            }
        } = this.state;

        const formattedFilters = {
            Property: {
                totalSubsidizedUnits: [parseFloat(minSubUnits), parseFloat(maxSubUnits)],
                totalPercentSubsidized: [parseFloat(minPerUnitSub), parseFloat(maxPerUnitSub)],
            },
            Subsidy: {
                Funding: funding,
                housingType: housing,
                RiskUnits: risk,
                Stewarding: stewarding,
                SubEnd: [subEndDateBegin, subEndDateEnd],
                SubStart: [subStartDateBegin, subStartDateEnd],
                UnitAMI: ami,
                tenantType: population,
            },
        }

        this.setState({ formattedFilters })
    }

    formatFiltersPipeline = () => {
        const {
            switchesInFilter:{
                tenure,
                affordabilityThreshold,
                afforabilityTerm,
                construction,
                permanentSupportativeHousing,
                communityLandTrust,
                greenCertified,
                innovation,
                nonprofit,
                bIPOC,
                families,
                seniors,
                formerlyHomeless,
            }
        } = this.state;

        const formattedFiltersPipeline = {
            Dropdown: {
                Tenure: tenure,
                AffordabilityThreshold: affordabilityThreshold,
                AffordabilityExpiration: afforabilityTerm,
            },
            Switch: {
                NewConstruction: construction,
                PSH: permanentSupportativeHousing,
                CLT: communityLandTrust,
                Green: greenCertified,
                Innovation: innovation,
                NPO: nonprofit,
                BIPOC: bIPOC,
                Families: families,
                Seniors: seniors,
                Homeless: formerlyHomeless,
            }
        
        }

        this.setState({ formattedFiltersPipeline })
    }

    setSelectedMenuItem = (selectedMenuItem) => {
        if (selectedMenuItem === 'Layers' || selectedMenuItem === 'Download') {
            this.setView(0)
        }
        if (selectedMenuItem === 'Download') {
            this.download();
        }
        this.setState({ selectedMenuItem })
    }

    setView = (mapOrTable) => {
        if (mapOrTable === 1) {
            this.setSelectedMenuItem()
        }
        this.setState({ mapOrTable })
    }

    setChoiceForTransitLayer = (transitDataFilterChoice) => {
     
        this.setState({ transitDataFilterChoice: transitDataFilterChoice })


    }

    generateTxtContent = () => {
        const { formattedFilters } = this.state;

        const queryMappings = {
            totalSubsidizedUnits: 'Total Subsidized Units in Building',
            totalPercentSubsidized: 'Percent Units Subsidized',
            Funding: 'Funding Source',
            HousingTyp: 'Housing Type',
            RiskUnits: 'At-Risk Units',
            Stewarding: 'Stewarding Agency',
            SubEnd: 'Subsidy End Date',
            SubStart: 'Subsidy Start Date',
            UnitAMI: 'Unit AMI',
            tenantType: 'Target Population',
        }
        const arr = formattedFilters ? getFiltersForTxt(formattedFilters) : null
        let str = '';
        if (arr) {
            arr.forEach(item => {
                const filter = Object.keys(item)[0]
                const value = Object.values(item)[0]
                str = str + `${queryMappings[filter]}: ${value}\n`
            })
        }
        return `QUERY\n\n${str ? 'FILTERED BY\n' + str : 'Entire data set exported'}`
    }

    async download() {
        const { requestedRef, filteredData } = this.state;

        try {
            // --------- Screenshot ---------
            const canvas = await html2canvas(requestedRef, { useCORS: true, allowTaint: true})
            const imgURI = canvas.toDataURL('image/png');
            const imgBlob = dataURItoBlob(imgURI);

            // --------- Query txt ---------
            const txt = this.generateTxtContent();
            const txtBlob = new Blob([txt], { type: "text/plain;charset=utf-8" });

            // --------- CSV ---------
            const flatData = transformDataForTable(filteredData.features)
            let csv = new ObjectsToCsv(flatData);
            let res = await csv.toString();
            const csvBlob = new Blob([res], { type: 'text/csv' });

            // --------- Zip ---------
            let zip = new JSZip();
            zip.file("map.png", imgBlob);
            zip.file("query.txt", txtBlob);
            zip.file("data.csv", csvBlob);
            let content = await zip.generateAsync({ type: 'blob' })
            const date = new Date();
            saveAs(content, `HouseATLData_${getMonth(date)}-${getDate(date)}_${getHours(date)}-${getMinutes(date)}-${getSeconds(date)}.zip`);
        } catch(err) {
            console.log('Error:', err)
        }
    }

    getRefFromChild = (childRef) => {
        this.setState({
            requestedRef: childRef
        });
    }

    render() {
        const {
            filterInputs,
            mapOrTable,
            selectedMenuItem,
            filteredData,
            filteredPipelineData,
            displayGeography,
            switches,
            showNoResultsModal,
            rawResultsCount,
            rawResultsCountPipeline,
            filterResultsCount,
            filterResultsCountPipeline,
            totalSubUnits,
            totalRiskUnits,
            totalSubUnitsPipeline,
            foodDesertData,
            transportationData,
            transitData ,
            lossAffordableHousingData,
            risingRentData ,
            raceData,
            foodDesertDataFilter,
            transportationDataFilter,
            transitDataFilter,
            lossAffordableHousingDataFilter,
            risingRentDataFilter,
            raceDataFilter,
            incomeDataFilter,
            filteredCurrentLayerData,
            transportationDataFilterRange,
            foodDesertDataFilterRange,
            lossAffordableHousingDataFilterRange,
            risingRentDataFilterRange,
            raceDataFilterRange,
            incomeDataFilterRange,
            transitDataFilterChoice,
            formattedFilters,
            formattedFiltersPipeline,
            filteredHousingDataByTransitLayerFilter,
            switchesInFilter,
            columnsPipeline
        } = this.state;

        const {
            user,
            loggedIn,
            uploadFile,
            clearUploadErrors,
            uploadData,
            isUploading,
            uploadError,
            fetchAgencyList,
            agencyList,
            fetchHousingNPUData,
            housingNPUData,
            housingData,
            pipelineData
        } = this.props;

        const MainView = (
            <Fragment>
                <FunctionArea
                    rawResultsCount = {rawResultsCount}
                    rawResultsCountPipeline = {rawResultsCountPipeline}
                    filterResultsCount={filterResultsCount}
                    filterResultsCountPipeline = {filterResultsCountPipeline}
                    totalSubUnits={totalSubUnits}
                    formattedFilters={formattedFilters}
                    totalRiskUnits={totalRiskUnits}
                    totalSubUnitsPipeline = {totalSubUnitsPipeline}
                    mapOrTable={mapOrTable}
                    setView={this.setView}
                    loggedIn={loggedIn}
                />
                {mapOrTable === 0 ? (
                    <Map
                        passRefUpward={this.getRefFromChild}
                        switches={switches}
                        housingData={filteredData}
                        pipelineData = {filteredPipelineData}
                        displayGeography={displayGeography}
                        fetchHousingNPUData = {fetchHousingNPUData}
                        housingNPUData = {housingNPUData}
                        foodDesertData = {foodDesertData}
                        transportationData = {transportationData}
                        transitData = {transitData}
                        lossAffordableHousingData = {lossAffordableHousingData}
                        risingRentData = {risingRentData}
                        raceData = {raceData}
                        foodDesertDataFilter= {foodDesertDataFilter}
                        transportationDataFilter= {transportationDataFilter}
                        transitDataFilter= {transitDataFilter}
                        lossAffordableHousingDataFilter= {lossAffordableHousingDataFilter}
                        risingRentDataFilter= {risingRentDataFilter}
                        raceDataFilter= {raceDataFilter}
                        incomeDataFilter= {incomeDataFilter}
                        filteredCurrentLayerData = {filteredCurrentLayerData}
                        resetFilteredData={this.resetFilteredData}
                        formattedFilters={formattedFilters}
                        formattedFiltersPipeline = {formattedFiltersPipeline}
                        housingDataOrigin = {housingData}
                        pipelineDataOrigin = {pipelineData}
                        applyLayerFilterTohouseData = {this.applyLayerFilterTohouseData}
                        filteredHousingDataByTransitLayerFilter = {filteredHousingDataByTransitLayerFilter}

                    />
                    
                ) : mapOrTable === -1 ? (
                    <SnapshotLeftTable
                        housingData={filteredData}
                        formattedFilters={formattedFilters}
                    />
                )
                :(
                    <TableView
                        housingData={filteredData}
                        pipelineData={filteredPipelineData}
                        columnsPipeline = {columnsPipeline}
                    />
                )}
            </Fragment>
        )

        return (
            <Fragment>
                <Sidebar
                    user={user}
                    loggedIn={loggedIn}
                    selected={selectedMenuItem}
                    setSelectedMenuItem={this.setSelectedMenuItem}
                    panel1={(
                        <Filters
                            filters={filterInputs}
                            makeDateHandler={this.makeDateHandler}
                            handleChange={this.handleFilterChange}
                            handleFilterChangePipeline = {this.handleFilterChangePipeline}
                            onSubmit={this.formatFilters}
                            onReset={this.resetFilters}
                            onSubmitPipeline={this.formatFiltersPipeline}
                            onResetPipeline={this.resetFiltersPipeline}
                            mapOrTable={mapOrTable}
                            // handleSwitchInFilter={this.handleSwitchInFilter}
                            switchesInFilter = {switchesInFilter}
                        />
                    )}
                    panel2={(
                        <Layers
                            switches={switches}
                            displayGeography={displayGeography}
                            handleChange={this.handleChange}
                            handleSwitch={this.handleSwitch}
                            handleLayerFilter = {this.handleLayerFilter}
                            foodDesertData = {foodDesertData}
                            transportationData = {transportationData}
                            transitData = {transitData}
                            lossAffordableHousingData = {lossAffordableHousingData}
                            risingRentData = {risingRentData}
                            raceData = {raceData}
                            transportationDataFilterRange={transportationDataFilterRange}
                            foodDesertDataFilterRange={foodDesertDataFilterRange}
                            lossAffordableHousingDataFilterRange={lossAffordableHousingDataFilterRange}
                            risingRentDataFilterRange={risingRentDataFilterRange}
                            raceDataFilterRange={raceDataFilterRange}
                            incomeDataFilterRange={incomeDataFilterRange}
                            transitDataFilterChoice={transitDataFilterChoice}
                            setChoiceForTransitLayer = {this.setChoiceForTransitLayer}
                        />
                    )}
                >
                    {(!selectedMenuItem || selectedMenuItem === 'Filters' || selectedMenuItem === 'Layers' || selectedMenuItem === 'Download') && (
                        MainView
                    )}
                    {selectedMenuItem === 'Snapshot' && (
                        <SnapshotContainer />
                    )}
                    {selectedMenuItem === 'Upload' && (
                        <UploadComponent
                            uploadFile={uploadFile}
                            clearUploadErrors={clearUploadErrors}
                            uploadData={uploadData}
                            isUploading={isUploading}
                            uploadError={uploadError}
                            fetchAgencyList={fetchAgencyList}
                            agencyList={agencyList}
                            userAgencyID={user.agency_id}
                        />
                    )}
                </Sidebar>
                <Modal
                    maxWidth="xs"
                    visible={showNoResultsModal}
                    title="No Results"
                    content="No properties match your query. Please retry the query with different filter selections."
                    onClose={() => this.setState({ showNoResultsModal: false })}
                />
            </Fragment>
        )
    }
}
export default DashboardComponent